/* eslint-disable @typescript-eslint/naming-convention */
export class TableInfoModel {
	public pk_composed: string;
	public workFileId: string;
	public name: string;
	public tableType: number;

	public constructor(info: Partial<TableInfoModel>) {
		this.workFileId = info.workFileId;
		this.tableType = info.tableType;
		this.name = info.name;
	}
}
